import React from 'react';
import { Navigate } from 'react-router-dom';
import { useInsuranceEnabled } from '../../../hooks/useInsuranceEnabled';

interface InsuranceFeatureGateProps {
  children: React.ReactNode;
  fallbackTo?: string;
}

/**
 * Redirects to the fallback route when insurance is disabled for the clinic.
 * Use this to block direct-URL access to insurance-only pages.
 */
export default function InsuranceFeatureGate({
  children,
  fallbackTo = '/billing',
}: InsuranceFeatureGateProps) {
  const insuranceEnabled = useInsuranceEnabled();
  if (!insuranceEnabled) {
    return <Navigate to={fallbackTo} replace />;
  }
  return <>{children}</>;
}
